
import { Link } from 'react-router-dom';

export default function ArticleHero() {
  return (
    <section className="pt-24 pb-12 bg-gradient-to-b from-gray-900 via-gray-800 to-white">
      <div className="max-w-4xl mx-auto px-6 pt-16 pb-8">
        <div className="mb-6 flex items-center gap-3 text-sm">
          <Link
            to="/blog"
            className="text-teal-400 hover:text-teal-300 transition-colors cursor-pointer"
          >
            Blog
          </Link>
          <span className="text-gray-500">/</span>
          <span className="text-gray-400">Accounting Software</span>
        </div>

        <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Top 7 Cloud-Based Accounting Softwares for Small Business
        </h1>

        <p className="text-lg text-gray-300 leading-relaxed mb-8 max-w-3xl">
          Choosing the right <strong>cloud-based accounting software</strong> can
          transform how you manage your finances. We break down the seven best
          platforms so you can find the perfect fit for your El Paso business.
        </p>

        <div className="flex items-center gap-6 text-sm text-gray-400">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-line"></i>
            </div>
            <span>January 15, 2025</span>
          </div>

          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-time-line"></i>
            </div>
            <span>12 min read</span>
          </div>

          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-line"></i>
            </div>
            <span>EP Bookkeeping Team</span>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6">
        <img
          src="https://public.readdy.ai/ai/img_res/d4ca19cd022d4e83d49de3bde04bbc49.jpg"
          alt="cloud-based-accounting-software-comparison-guide"
          title="Top 7 Cloud-Based Accounting Softwares for Small Business"
          className="w-full h-[400px] object-cover object-top rounded-2xl shadow-2xl"
        />
      </div>
    </section>
  );
}
